import {
  registerRongYunAccount,
  banUserSpeak,
  queryChatPeopleCount,
  getLotChatVideoList,
  queryChatRooms,
  checkChatRoomPassword,
  queryChatRoomComboBox,
  queryCheckChatRoomPwd,
  queryChatCustComerService,
  queryChatPersons
} from "@/api/chat";
import { redpacketList } from "@/api/user";
import {
  SET_CHAT_USER,
  SET_CHATUSER_KEY_VAL,
  ADD_CHATROOM_MSG,
  // SET_CHATROOM_PERERSON_INFO,
  SET_CHATROOM_PRIZE_INFO,
  SET_CHATROOM_NOTICE_MODIFY,
  SET_CHATROOM_All_SPEACKSTATUS,
  SET_CHATROOM_HEADLINE,
  SET_CHATROOM_SCROLL_TO_PIN,
  SET_CHATROOM_PIN_TIMER,
  SET_CHATROOM_REDPACKET_TRANSLATE_X,
  SET_CHATROOM_REDPACKET_INFO,
  SET_CHATROOM_VISIBLE_OPEN_REDPACKET,
  SET_CHATROOM_OPEN_REDPACKET_INFO,
  SET_CHATROOM_VISIBLE_REDPACKET_DETAIL,
  SET_CHATROOM_REDPACKET_MONEYINFO,
  SET_CHATROOM_REDPACKET_LIST,
  SET_CHATROOM_REDPACKET_DSC,
  SET_CHATROOM_ANNOUNCE_INFO,
  SET_CHATROOM_VISIBLE_FOLLOW_ORDER,
  SET_CHATROOM_FOLLOW_ORDER_INFO,
  SET_CHATROOM_FOLLOW_ORDER_TIMETXT,
  SET_CHATROOM_FOLLOW_ORDER_BETTING_MONEY,
  SET_CHATROOM_FOLLOW_ORDER_BETTING_CLOSE,
  SET_CHATROOM_FOLLOW_REQORDER_INFO,
  SET_CHATROOM_FOLLOW_ORDER_TIMER,
  CLEAR_CHATROOM_MESSAGE_LIST,
  SET_CHATROOM_MESSAGE_LIST,
  // SET_CHATROOM_INFO,
  SET_CHATROOM_LIST,
  // SET_CHAT_ISHIDE_PWDVIEW,
  SET_CHAT_ROOM_PRIVATE_MSG_LIST,
  ADD_SINGLE_PRIVATE_MSG,
  ADD_CHAT_ROOM_SELF_MSG,
  QUERY_CHAT_ROOM_PERSONS,
  SET_PRIVATE_ROOM_TARGET_ID,
  IS_SHOW_SINGLE_PRIVATE_MSG_NOTICE,
  IS_OPEN_PRIVATE_MSG_NOTICE_SWITCH,
  IS_OPEN_CHAT_ROOM_PRIZE_NOTICE,
  SET_WILL_SWITCH_CHAT_ROOM_INFO,
  SET_CURR_CHAT_ROOM_INFO,
  SET_CURR_CHAT_ROOM_USER_INFO,
  SET_CHATROOM_JOIN_STATE,
  CHANGE_CURR_CHAT_USER_INFO,
  SET_CHATROOM_LAYOUT_GAME,
  SET_CHATROOM_INSTANCE_SPEAK_STATUS,
  SET_CURRENT_CHAT_PRIVATE_RECEIVE_USER,
  SET_CURRENT_CHAT_PRIVATE_VIPINFO,
  SET_CHAT_PUSH_MEMBER_MSG,
  SET_RY_CONNECT_SUCCESS,
  SET_CHAT_LOADING_MORE_MESSAGE,
  UPDATE_CHAT_CONTACT,
  SET_CHAT_CURRENT_CONTACT
} from "@/store/mutation_types";
import { isNotEmpty, isEmpty } from "@/utils";
import EventBus from "@/utils/eventBus";

const chat = {
  state: {
    chatUser: {},
    joinState: 0, //加入聊天室是否成功
    // chatRoomInfo: {}, // 聊天室信息
    chatRoomMsg: {},
    currentContact: {},
    // chatRoomPersonInfo: {},
    chatRoomPrizeInfo: {}, //聊天室用户中奖消息
    chatRoomAllSpeakStatus: true, //全员禁言的状态
    noticeModify: {},
    peopleCountInfo: {},
    chatHeadLine: {}, //彩票头条
    chatVisiblePin: false,
    chatScrollToPin: 0, // 触发滚动到置顶消息函数
    chatPinTimer: null,
    chatVisibleSendRedPacket: false,
    redPacketTranslateX: "0", //红包详情窗口的偏移,
    redPacketInfo: {},
    chatVisibleOpenRedPacket: false,
    openRedPacketInfo: {
      content: "",
      user: "",
      self: false,
      redPacketStatus: 0,
      redPacketDesc: ""
    },
    chatVisibleRedPacketDetail: false,
    redPacketMoneyInfo: {
      money: ""
    },
    chatRedPacketList: [],
    chatRedPacketDesc: "",
    chatAnnounceInfo: {},
    chatVisibleFollowOrder: false, // 显示/隐藏 跟单对话框
    chatFollowOrderInfo: {},
    chatFollowOrderTimeTxt: "00:00:00",
    chatFollowOrderBettingMoney: 10,
    chatFollowOrderCloseBetting: false, // 是否封盘
    chatFollowOrderReqInfo: {},
    chatFollowOrderTimer: null,
    chatMessageList: [],
    chatRoomList: [],
    // chatRoomIsHidePwdView: false,
    chatRoomPrivateMsgList: [], //聊天室私聊会话消息列表
    chatRoomSinglePrivateMsg: "", //私聊单个消息
    chatRoomSelfMsg: "", //聊天室自己的消息发到消息列表
    chatRoomPersons: "", //聊天室真实人员列表，包含游客
    privateRoomTargetId: "", //当前私聊房间对方的Id
    isShowSinglePrivateMsgNotice: {}, //是否显示私聊消息的通知
    isOpenPrivateMsgNoticeSwitch: true, //是否打开私聊消息通知开关
    isOpenChatRoomPrizeNotice: true, // 是否打开聊天室开间公告通知开关
    // rqChatRoomInfo: {}, //当前聊天室房间id等信息
    currChatRoomInfo: {}, // 房间信息
    currChatRoomUserInfo: {}, // 当前房间用户的信息
    willSetChatRoomInfo: {}, //将要设置为聊天室房间的信息
    changedCurrChatRoomUserInfo: {}, // 后台管理系统修改用户的发言状态等信息
    chatGameLayout: 0, // 触发聊天室游戏布局函数
    chatRoomInstanceSpeakStatus: {}, // 接收即使聊天室是否开启即时聊天模式
    curPrivateChatReceiveUser: {},
    curPrivateChatVipInfo: {},
    chatPushMemberMsg: {}, // 后台推送会员消息
    ryConnectSuccess: false
  },
  getters: {
    changedCurrChatRoomUserInfo: state => state.changedCurrChatRoomUserInfo,
    joinState: state => state.joinState,
    willSetChatRoomInfo: state => state.willSetChatRoomInfo,
    currChatRoomInfo: state => state.currChatRoomInfo,
    currChatRoomUserInfo: state => state.currChatRoomUserInfo,
    // rqChatRoomInfo: state => state.rqChatRoomInfo,
    // chatRoomInfo: state => state.chatRoomInfo,
    chatUser: state => state.chatUser,
    chatRoomMsg: state => state.chatRoomMsg,
    chatCurrentContact: state => state.currentContact,
    chatRoomPersonInfo: state => state.chatRoomPersonInfo,
    chatRoomPrizeInfo: state => state.chatRoomPrizeInfo,
    chatRoomAllSpeakStatus: state => state.chatRoomAllSpeakStatus,
    noticeModify: state => state.noticeModify,
    chatRoomPeopleCountInfo: state => state.peopleCountInfo,
    chatHeadLine: state => state.chatHeadLine,
    chatVisiblePin: state => state.chatVisiblePin,
    chatScrollToPin: state => state.chatScrollToPin,
    chatPinTimer: state => state.chatPinTimer,
    chatVisibleSendRedPacket: state => state.chatVisibleSendRedPacket,
    chatRedPacketTranslateX: state => state.redPacketTranslateX,
    chatRedPacketInfo: state => state.redPacketInfo,
    chatVisibleOpenRedPacket: state => state.chatVisibleOpenRedPacket,
    chatOpenRedPacketInfo: state => state.openRedPacketInfo,
    chatVisibleRedPacketDetail: state => state.chatVisibleRedPacketDetail,
    chatRedPacketMoneyInfo: state => state.redPacketMoneyInfo,
    chatRedPacketList: state => state.chatRedPacketList,
    chatRedPacketDesc: state => state.chatRedPacketDesc,
    chatAnnounceInfo: state => state.chatAnnounceInfo,
    chatVisibleFollowOrder: state => state.chatVisibleFollowOrder,
    chatFollowOrderInfo: state => state.chatFollowOrderInfo,
    chatFollowOrderTimeTxt: state => state.chatFollowOrderTimeTxt,
    chatFollowOrderBettingMoney: state => state.chatFollowOrderBettingMoney,
    chatFollowOrderCloseBetting: state => state.chatFollowOrderCloseBetting,
    chatFollowOrderReqInfo: state => state.chatFollowOrderReqInfo,
    // chatTabCurrentMsg: state => state.chatTabCurrentMsg,
    chatFollowOrderTimer: state => state.chatFollowOrderTimer,
    chatMessageList: state => state.chatMessageList,
    chatRoomList: state => state.chatRoomList,
    // chatRoomIsHidePwdView: state => state.chatRoomIsHidePwdView,
    chatRoomPrivateMsgList: state => state.chatRoomPrivateMsgList,
    chatRoomSinglePrivateMsg: state => state.chatRoomSinglePrivateMsg,
    chatRoomSelfMsg: state => state.chatRoomSelfMsg,
    chatRoomCustomerMsg: state => state.chatRoomCustomerMsg,
    chatRoomPersons: state => state.chatRoomPersons,
    privateRoomTargetId: state => state.privateRoomTargetId,
    isShowSinglePrivateMsgNotice: state => state.isShowSinglePrivateMsgNotice,
    isOpenPrivateMsgNoticeSwitch: state => state.isOpenPrivateMsgNoticeSwitch,
    isOpenChatRoomPrizeNotice: state => state.isOpenChatRoomPrizeNotice,
    chatGameLayout: state => state.chatGameLayout,
    chatRoomInstanceSpeakStatus: state => state.chatRoomInstanceSpeakStatus,
    curPrivateChatReceiveUser: state => state.curPrivateChatReceiveUser,
    curPrivateChatVipInfo: state => state.curPrivateChatVipInfo,
    chatPushMemberMsg: state => state.chatPushMemberMsg,
    chatRyConnectSuccess: state => state.ryConnectSuccess
  },
  mutations: {
    [SET_CHAT_PUSH_MEMBER_MSG]: (state, payload) => {
      state.chatPushMemberMsg = payload;
    },
    [SET_RY_CONNECT_SUCCESS]: (state, playload) => {
      state.ryConnectSuccess = playload;
    },
    [SET_CURRENT_CHAT_PRIVATE_VIPINFO]: (state, payload) => {
      state.curPrivateChatVipInfo = payload;
    },
    [SET_CURRENT_CHAT_PRIVATE_RECEIVE_USER]: (state, payload) => {
      state.curPrivateChatReceiveUser = payload;
    },
    [SET_CHATROOM_INSTANCE_SPEAK_STATUS]: (state, payload) => {
      state.chatRoomInstanceSpeakStatus = payload;
    },
    [CHANGE_CURR_CHAT_USER_INFO]: (state, payload) => {
      state.changedCurrChatRoomUserInfo = payload;
    },
    [SET_CURR_CHAT_ROOM_USER_INFO]: (state, payload) => {
      state.currChatRoomUserInfo = payload;
    },
    [SET_WILL_SWITCH_CHAT_ROOM_INFO]: (state, payload) => {
      state.willSetChatRoomInfo = payload;
    },
    [SET_CHATROOM_LAYOUT_GAME]: (state, payload) => {
      state.chatGameLayout = ~state.chatGameLayout;
    },
    [SET_CURR_CHAT_ROOM_INFO]: (state, payload) => {
      state.currChatRoomInfo = payload;
    },
    [UPDATE_CHAT_CONTACT]: (state, playload) => {
      const { contact } = playload;
      const contactsList = state.contactsList;

      if (contact.userInfo.id) {
        let index = contactsList.findIndex(
          item => item.userInfo.id === contact.userInfo.id
        );

        contactsList.splice(index, 1, contact);
        state.contactsList = contactsList;
      }
    },
    // [RQ_SET_CHAT_ROOM_INFO]: (state,payload) => {
    //   state.rqChatRoomInfo = payload;
    // },
    [SET_CHAT_USER]: (state, payload) => {
      state.chatUser = payload;
    },
    // [SET_CHAT_ISHIDE_PWDVIEW]: (state, payload) => {
    //   state.chatRoomIsHidePwdView = payload;
    // },
    // [SET_CHATROOM_INFO]: (state, payload) => {
    //   state.chatRoomInfo = payload;
    // },
    [SET_CHATROOM_LIST]: (state, payload) => {
      state.chatRoomList = payload;
    },
    [SET_CHATUSER_KEY_VAL]: (state, payload) => {
      for (let k in payload) {
        state.chatUser[k] = payload[k];
      }
    },
    [ADD_CHATROOM_MSG]: (state, payload) => {
      state.chatRoomMsg = payload;
    },
    // [SET_CHATROOM_PERERSON_INFO]: (state, payload) => {
    //   state.chatRoomPersonInfo = payload;
    // },
    [SET_CHATROOM_PRIZE_INFO]: (state, payload) => {
      state.chatRoomPrizeInfo = payload;
    },
    [SET_CHATROOM_NOTICE_MODIFY]: (state, payload) => {
      EventBus.dispatch("updatePrizeHistory", payload);
      state.noticeModify = payload;
    },
    [SET_CHATROOM_All_SPEACKSTATUS]: (state, payload) => {
      state.chatRoomAllSpeakStatus = payload;
    },
    [SET_CHATROOM_JOIN_STATE]: (state, payload) => {
      state.joinState = payload;
    },
    [SET_CHAT_LOADING_MORE_MESSAGE]: (state, playload) => {
      state.isLoadingMoreMessage = playload;
    },
    [SET_CHAT_CURRENT_CONTACT]: (state, playload) => {
      state.currentContact = playload;
    },
    // [SET_CHATROOM_PEOPLECOUNT_INFO]: (state, payload = {}) => {
    //   const { data} = payload;
    //   state.peopleCountInfo = data;
    // if (isEmpty(payload) || (isEmpty(data) && isEmpty(mode))) {
    //   throw new Error("SET_CHATROOM_PEOPLECOUNT_INFO:错误的传参方式");
    // }
    // if (mode === "replace") {
    //   return (state.peopleCountInfo = data);
    // }
    // if (mode === "assign") {
    //   return (state.peopleCountInfo = {
    //     ...state.peopleCountInfo,
    //     ...data
    //   });
    // }
    // throw new Error("SET_CHATROOM_PEOPLECOUNT_INFO:mode可选值（空,assign）");
    // },
    // [SET_CHATROOM_VARIOUT_MSG]: (state, payload) => {
    //   state.chatRoomVariousMsg = payload;
    // },
    [SET_CHATROOM_HEADLINE]: (state, payload) => {
      state.chatHeadLine = payload;
    },
    // [SET_CHATROOM_VISIBLE_PIN]: (state, payload) => {
    //   state.chatVisiblePin = payload;
    // },
    [SET_CHATROOM_SCROLL_TO_PIN]: (state, payload) => {
      state.chatScrollToPin = ~state.chatScrollToPin;
    },
    // [SET_CHATROOM_PIN_MSG]: (state, payload) => {
    //   state.chatPinMsg = payload;
    // },
    [SET_CHATROOM_PIN_TIMER]: (state, payload) => {
      state.chatPinTimer = payload;
    },
    // [SET_CHATROOM_AITE_INFO]: (state, payload) => {
    //   state.chatAiTeInfo = payload;
    // },
    // [SET_CHATROOM_VISIBLE_REDPACKET]: (state, payload) => {
    //   state.chatVisibleRedPacket = payload;
    // },
    // [SET_CHATROOM_VISIBLE_ASIDERANK]: (state, payload) => {
    //   state.chatVisibleAsideRank = payload;
    // },
    // [SET_CHATROOM_VISIBLE_ZHUDAN]: (state, payload) => {
    //   state.chatVisibleZhuDan = payload;
    // },
    // [SET_CHATROOM_VISIBLE_SIGN_POPUP]: (state, payload) => {
    //   state.chatVisibleSignPopup = payload;
    // },
    // [SET_CHATROOM_VISIBLE_SEND_REDPACKET]: (state, payload) => {
    //   state.chatVisibleSendRedPacket = payload;
    // },
    [SET_CHATROOM_REDPACKET_TRANSLATE_X]: (state, payload) => {
      state.redPacketTranslateX = payload;
    },
    [SET_CHATROOM_REDPACKET_INFO]: (state, payload) => {
      const { data, mode } = payload;
      if (isEmpty(payload) || (isEmpty(mode) && isEmpty(data))) {
        throw new Error("SET_CHATROOM_REDPACKET_INFO:错误的传参方式");
      }
      if (mode === "replace") {
        return (state.redPacketInfo = data);
      }
      if (mode === "assign") {
        return (state.redPacketInfo = {
          ...state.redPacketInfo,
          ...data
        });
      }
      throw new Error("SET_CHATROOM_REDPACKET_INFO:mode可选值（空,assign）");
    },
    [SET_CHATROOM_VISIBLE_OPEN_REDPACKET]: (state, payload) => {
      state.chatVisibleOpenRedPacket = payload;
    },
    [SET_CHATROOM_OPEN_REDPACKET_INFO]: (state, payload) => {
      const { data, mode } = payload;
      if (isEmpty(payload) || (isEmpty(mode) && isEmpty(data))) {
        throw new Error("SET_CHATROOM_OPEN_REDPACKET_INFO:错误的传参方式");
      }
      if (mode === "replace") {
        return (state.openRedPacketInfo = data);
      }
      if (mode === "assign") {
        return (state.openRedPacketInfo = {
          ...state.openRedPacketInfo,
          ...data
        });
      }
      throw new Error(
        "SET_CHATROOM_OPEN_REDPACKET_INFO:mode可选值（空,assign）"
      );
    },
    [SET_CHATROOM_VISIBLE_REDPACKET_DETAIL]: (state, payload) => {
      state.chatVisibleRedPacketDetail = payload;
    },
    [SET_CHATROOM_REDPACKET_MONEYINFO]: (state, payload) => {
      state.redPacketMoneyInfo = payload;
    },
    [SET_CHATROOM_REDPACKET_LIST]: (state, payload) => {
      state.chatRedPacketList = payload;
    },
    [SET_CHATROOM_REDPACKET_DSC]: (state, payload) => {
      state.chatRedPacketDesc = payload;
    },
    [SET_CHATROOM_ANNOUNCE_INFO]: (state, payload) => {
      state.chatAnnounceInfo = payload;
    },
    // [SET_CHATROOM_VISIBLE_MSG_ACTION_MENU]: (state, payload) => {
    //   state.chatVisibleMsgActionMenu = payload;
    // },
    [SET_CHATROOM_VISIBLE_FOLLOW_ORDER]: (state, payload) => {
      state.chatVisibleFollowOrder = payload;
    },
    [SET_CHATROOM_FOLLOW_ORDER_INFO]: (state, payload) => {
      const { data, mode } = payload;
      if (isEmpty(payload) || (isEmpty(mode) && isEmpty(data))) {
        throw new Error("SET_CHATROOM_FOLLOW_ORDER_INFO:错误的传参方式");
      }
      if (mode === "replace") {
        return (state.chatFollowOrderInfo = data);
      }
      if (mode === "assign") {
        return (state.chatFollowOrderInfo = {
          ...state.chatFollowOrderInfo,
          ...data
        });
      }
      throw new Error("SET_CHATROOM_FOLLOW_ORDER_INFO:mode可选值（空,assign）");
    },
    [SET_CHATROOM_FOLLOW_ORDER_TIMETXT]: (state, payload) => {
      state.chatFollowOrderTimeTxt = payload;
    },
    [SET_CHATROOM_FOLLOW_ORDER_BETTING_MONEY]: (state, payload) => {
      state.chatFollowOrderBettingMoney = payload;
    },
    [SET_CHATROOM_FOLLOW_ORDER_BETTING_CLOSE]: (state, payload) => {
      state.chatFollowOrderCloseBetting = payload;
    },
    [SET_CHATROOM_FOLLOW_REQORDER_INFO]: (state, payload) => {
      const { data, mode } = payload;
      if (isEmpty(payload) || (isEmpty(mode) && isEmpty(data))) {
        throw new Error("SET_CHATROOM_FOLLOW_REQORDER_INFO:错误的传参方式");
      }
      if (mode === "replace") {
        return (state.chatFollowOrderReqInfo = data);
      }
      if (mode === "assign") {
        return (state.chatFollowOrderReqInfo = {
          ...state.chatFollowOrderReqInfo,
          ...data
        });
      }
      throw new Error(
        "SET_CHATROOM_FOLLOW_REQORDER_INFO:mode可选值（空,assign）"
      );
    },
    // [SET_CHATROOM_TAB_CUREENT_MSG]: (state, payload) => {
    //   state.chatTabCurrentMsg = payload;
    // },
    [SET_CHATROOM_FOLLOW_ORDER_TIMER]: (state, payload) => {
      state.chatFollowOrderTimer = payload;
    },
    [SET_CHATROOM_MESSAGE_LIST]: (state, payload) => {
      state.chatMessageList = payload;
    },
    [CLEAR_CHATROOM_MESSAGE_LIST]: (state, payload) => {
      state.chatMessageList = [];
    },
    [SET_CHAT_ROOM_PRIVATE_MSG_LIST]: (state, payload) => {
      //聊天室私聊消息会话列表
      state.chatRoomPrivateMsgList = payload;
    },
    [ADD_SINGLE_PRIVATE_MSG]: (state, payload) => {
      //接收单个消息
      state.chatRoomSinglePrivateMsg = payload;
    },
    [ADD_CHAT_ROOM_SELF_MSG]: (state, payload) => {
      //聊天室自己发的消息
      state.chatRoomSelfMsg = payload;
    },
    [QUERY_CHAT_ROOM_PERSONS]: (state, payload) => {
      state.chatRoomPersons = payload;
    },
    [SET_PRIVATE_ROOM_TARGET_ID]: (state, payload) => {
      //设置当前私聊房间对方Id
      state.privateRoomTargetId = payload;
    },
    [IS_SHOW_SINGLE_PRIVATE_MSG_NOTICE]: (state, payload) => {
      //是否显示私聊消息通知
      state.isShowSinglePrivateMsgNotice = payload;
    },
    [IS_OPEN_PRIVATE_MSG_NOTICE_SWITCH]: (state, payload) => {
      //是否打开私聊消息通知开关
      state.isOpenPrivateMsgNoticeSwitch = payload;
    },
    [IS_OPEN_CHAT_ROOM_PRIZE_NOTICE]: (state, payload) => {
      //是否打开了聊天室开奖公告
      state.isOpenChatRoomPrizeNotice = payload;
    }
  },
  actions: {
    async registerRongYunAccount({ state, commit, rootState, dispatch }, user) {
      // let resp;
      // if (user.userCode) { //登录用户
      //   resp = await dispatch("getRyToken");
      //   const { data, code } = resp.data;
      //   if (code == 0) {
      //     commit(SET_CHAT_USER, {
      //       uid: user.userId,
      //       portrait: user.imgUrl,
      //       name: user.userCode,
      //       nickName: user.nickName,
      //       userLevelIcon: user.userLevelIcon,
      //       token: data.token
      //     });
      //   }
      // } else { //未登录用户
      //   let chatUserId = localStorage.getItem("platChatUserId");
      //   chatUserId = isNotEmpty(chatUserId) ? chatUserId : uuid(30, 30);
      //   resp = await registerRongYunAccount({
      //     rongYunUserId: chatUserId
      //   });
      //   const { data, code } = resp.data;
      //   if (code == 0) {
      //     localStorage.setItem("platChatUserId", data.rongYunUserId);
      //     commit(SET_CHAT_USER, {
      //       uid: data.rongYunUserId,
      //       name: data.userCode,
      //       token: data.token
      //     });
      //   }
      // }
      // return resp;
    },

    //查询聊天室人数、是否为管理员等信息
    async queryChatPeopleInfo({ commit, getters, dispatch }, playload) {
      let [chatId, roomId, userId] = ["", "", getters.user.userId];
      if (!playload) {
        //系统房
        await dispatch("getAppConfig");
        chatId = getters.appConfig.messageChatRoomId;
        roomId = "1";
      } else {
        //非系统房
        chatId = playload.ryChatRoomId;
        roomId = playload.roomId;
      }
      const res = await queryChatPeopleCount({
        chatId,
        roomId,
        userId
      });
      const {
        data: { code, data = {} }
      } = res;
      if (code === 0) {
        data.isAdmin = data.isAdmin === "1" ? true : false;
        data.isCustomerService = data.isCustomerService === "-1" ? false : true;
        data.privateChat = data.privateChat === "1" ? true : false;
        commit(SET_CURR_CHAT_ROOM_USER_INFO, data);
        return data;
      }
      return {};
    },

    //查询游客信息
    async queryChatPersons({ commit }, playload) {
      return await queryChatPersons(playload.data, playload.config);
    },

    //查询聊天室房间列表信息
    async queryChatRoomComboBox({ commit }, playload) {
      let res = await queryChatRoomComboBox(playload.data, playload.config);
      const { data, code } = res.data;
      if (code === 0) {
        commit(SET_CHATROOM_LIST, data);
      }
      return res;
    },

    /**
     * 加载更多历史记录
     * @param {*} param0
     * @param {*} playload
     */
    async loadMoreMessage({ state, rootState, commit }, playload) {
      const currentContact = state.currentContact;

      let timestamp = null;
      if (currentContact.msgList && currentContact.msgList.length) {
        timestamp = currentContact.msgList[0].sentTime;
      }
      commit("SET_CHAT_LOADING_MORE_MESSAGE", true);
      const hisResult = await RongYun.getHistoryMessages(
        RongIMLib.ConversationType.CHATROOM,
        currentContact.userInfo.id,
        {
          timestamp
        }
      ); //拉取历史数据

      const hisMessage = hisResult.list;
      const historyDelMsgList = [];
      const historyFilterMsgList = [];

      for (let i = 0; i < hisMessage.length; i++) {
        const curMessage = hisMessage[i];

        if (curMessage.content && curMessage.content.user) {
          let extra = curMessage.content.extra;
          if (typeof extra === "string") {
            extra = JSON.parse(extra);
          }
          if (extra && extra.type === "100") {
            historyDelMsgList.push(extra);
            continue;
          }
          // curMessage.content.user.userCode = extra.senderUser.userCode;
        }

        historyFilterMsgList.push(RongYun.redPacketMsgHandler(curMessage));
      }

      const beforeLength = currentContact.msgList.length;
      let msgList = (currentContact.msgList = historyFilterMsgList.concat(
        ...currentContact.msgList
      ));
      for (let i = 0; i < historyDelMsgList.length; i++) {
        const historyDelMsg = historyDelMsgList[i];
        // 删除消息
        for (let i = 0; i < msgList.length; ) {
          if (
            msgList[i] &&
            historyDelMsg.messageUId === msgList[i].messageUId
          ) {
            msgList.splice(i, 1);
            if (msgList[i - 1] && msgList[i - 1].timeState) {
              msgList.splice(i - 1, 1);
              i > 0 && i--;
            }
            break;
          }
          i++;
        }
      }
      const afterLength = currentContact.msgList.length;

      currentContact.msgList = currentContact.msgList.filter(item => item);
      commit("SET_CHAT_CURRENT_CONTACT", currentContact);
      commit("UPDATE_CHAT_CONTACT", {
        contact: currentContact
      });
      commit("SET_CHAT_LOADING_MORE_MESSAGE", false);
      return afterLength !== beforeLength;
    },

    async banUserSpeak({ commit }, payload) {
      const res = await banUserSpeak(payload);
      const {
        data: { data = {} }
      } = res;
      return res;
    },
    async checkChatRoomPassword({ commit }, payload) {
      const res = await checkChatRoomPassword(payload.data, payload.config);
      const {
        data: { data = {}, code }
      } = res;
      return code === 0;
    },

    // //查询聊天室人数等信息
    // async queryChatPeopleCount({ state, dispatch, getters, commit }) {
    //   let chatRoomInfo = state.chatRoomInfo;
    //   let { ryChatRoomId,roomId } = chatRoomInfo;
    //   if(!roomId) return;
    //   if (!ryChatRoomId) { //系统房
    //     await dispatch("getAppConfig");
    //     ryChatRoomId = getters.appConfig.messageChatRoomId;
    //     chatRoomInfo.messageChatRoomId;
    //     commit(SET_CHATROOM_INFO, {
    //       isBannedLevel: true
    //     });
    //   }
    //   if (ryChatRoomId) { //非系统房
    //     const payload = {
    //       chatId: ryChatRoomId,
    //       userId: getters.user.userId,
    //       roomId: roomId
    //     };
    //     const res = await queryChatPeopleCount(payload);
    //     const {
    //       data: { code, data = {} }
    //     } = res;
    //     if (code != 0) {
    //       return res;
    //     }
    //     commit(SET_CHATROOM_PEOPLECOUNT_INFO, {
    //       mode: "replace",
    //       data
    //     });
    //     return res;
    //   }
    //   return;
    // },
    async getLotChatVideoList({ commit }, payload) {
      const { data, config } = payload;
      const res = await getLotChatVideoList(data, config);
      const ret = res.data.data;
      return res;
    },
    // async startChatRoomPinTimer(
    //   { getters, commit },
    //   payload = {
    //     data: {},
    //     timestamp: 120000
    //   }
    // ) {
    //   if (getters.chatPinTimer) clearTimeout(getters.chatPinTimer);
    //   // commit(SET_CHATROOM_VISIBLE_PIN, true);
    //   commit(SET_CHATROOM_PIN_MSG, payload.data);
    //   if (payload.timestamp === 0) return;
    //   commit(
    //     SET_CHATROOM_PIN_TIMER,
    //     setTimeout(() => {
    //       commit(SET_CHATROOM_PIN_MSG, "");
    //       // commit(SET_CHATROOM_VISIBLE_PIN, false);
    //     }, payload.timestamp)
    //   );
    // },
    // async stopChatRoomPinTimer(
    //   { getters, commit },
    //   payload = {
    //     timestamp: 0
    //   }
    // ) {
    //   if (payload.timestamp) {
    //     commit(
    //       SET_CHATROOM_PIN_TIMER,
    //       setTimeout(() => {
    //         commit(SET_CHATROOM_PIN_MSG, "");
    //         commit(SET_CHATROOM_VISIBLE_PIN, false);
    //       }, payload.timestamp)
    //     );
    //   } else {
    //     clearTimeout(getters.chatPinTimer);
    //   }
    // },
    async queryChatRedpacketList({ commit }, payload) {
      const res = await redpacketList(payload.data, payload.config);
      // debugger;
      const {
        data: { code, data = {} }
      } = res;
      if (code === 0) {
        commit(SET_CHATROOM_REDPACKET_LIST, data.redpacketList);
        commit(SET_CHATROOM_REDPACKET_MONEYINFO, {
          money: data.selfRedpacket ? data.selfRedpacket.money : ""
        });
        commit(SET_CHATROOM_REDPACKET_DSC, data.redpacketDesc);
      }
      return res;
    },
    async queryChatRooms({ commit }, playload) {
      return await queryChatRooms(playload.data, playload.config);
    },
    async queryCheckChatRoomPwd({ commit }, playload) {
      return await queryCheckChatRoomPwd(playload.data, playload.config);
    },
    async queryChatCustComerService({ commit }, playload) {
      return await queryChatCustComerService(playload.data, playload.config);
    }
  }
};

export default chat;
